import React, { useState } from 'react';
import clsx from 'clsx';
import { Auth } from "aws-amplify";

import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Badge, Hidden, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import includes from 'lodash/includes';

import { UserMenu, Schedule, Changelog, Roadmap } from './components';
import { CURRENT_ENV, CURRENT_VERSION } from '../../../../utils/constants';
import { useUserGroups } from '../../../../utils/use-user';

const useStyles = makeStyles(theme => ({
    root: {
      boxShadow: 'none'
    },
    flexGrow: {
      flexGrow: 1
    },
    signOutButton: {
      marginLeft: theme.spacing(1),
    },
    userText: {
      fontWeight: 500
      // marginLeft: 10,
    },
    version:{
      marginLeft: 10,
      marginTop: 10,
      fontWeight: 600
    },
    logo: {
      height: 24
    }
  }));
  
const Topbar = ({ className, onSidebarOpen, ...rest }) => {
    const classes = useStyles();
    const groups = useUserGroups();
    const isManager = includes(groups, 'manager');
    const isAdmin = includes(groups, 'admin');
    const isEditor = includes(groups, 'editor');

    return (
        // <div>Hello</div>
      <AppBar
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Toolbar>
          <Hidden lgUp>
            <IconButton
              color="inherit"
              onClick={onSidebarOpen}
            >
              <MenuIcon />
            </IconButton>
          </Hidden>
            <img
            className={classes.logo}
            alt="Logo"
            src="/static/images/logo/panafold-connect-logo-white.png"
            // width="160"
            height="24px"
          />
            {/* <Typography className={classes.version}>v.{CURRENT_VERSION}</Typography> */}
            <If condition={CURRENT_ENV != 'production'}>
              <Typography className={classes.version}>env: {CURRENT_ENV}</Typography>
            </If>
          <div className={classes.flexGrow} />
            {/* <Roadmap /> */}
            {/* <Changelog /> */}
            <If condition={isManager || isAdmin || isEditor}>
              <Schedule />
            </If>
            <UserMenu className={classes.signOutButton} user={Auth.user.attributes?.email}/>
        </Toolbar>
      </AppBar>
    );
  };

export default Topbar;